<p-toast key="tst" position="top-center" styleClass="custom-toast">
  <ng-template let-message pTemplate="message">
    <span class="p-toast-message-icon pi" [ngClass]="icon"></span>
      <div class="p-toast-message-text">
        <div class="p-toast-summary">{{message.summary}}</div>
        <div class="p-toast-detail" innerHtml="{{message.detail}}"></div>
      </div>
  </ng-template>
</p-toast>
